// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + {"14":"css/idx-catalog","114":"css/text","266":"css/style","450":"css/idx-detail","501":"css/backend","848":"css/idx","887":"css/frontend"}[chunkId] + ".css";
};